export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_0f83cc95-937a-4b02-919b-886257e3a23e/artifacts/a2lphopf_Picsart_26-07-11_00-42-07-529.png";

export const COMPANY = {
    name: "CHANDAK BuildVision",
    tagline: "Feel Before You Build.",
    phone: "9542708120",
    phoneIntl: "+919542708120",
    email: "chandakbuilders1331@gmail.com",
    location: "Hyderabad, Telangana, India",
    socials: {
        instagram:
            "https://www.instagram.com/as_designer1331?igsh=MWsxa251Y2hsZjM1Zw==",
        linkedin:
            "https://www.linkedin.com/in/chandak-ankit-742651372?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        facebook: "https://www.facebook.com/share/1BNkoTP3Xw/",
        youtube: "https://youtube.com/@chandak_buildvision?si=c1y9tn1FMD2DGcjs",
    },
};

export const HERO_IMAGE =
    "https://images.pexels.com/photos/31737860/pexels-photo-31737860.jpeg";

export const FOUNDER = {
    name: "Chandak Ankit",
    title: "Founder & CEO",
    image:
        "https://customer-assets.emergentagent.com/job_design-experience-11/artifacts/jljfedrh_WhatsApp%20Image%202026-07-11%20at%206.04.38%20PM.jpeg",
    bio: "A designer at heart and a builder by conviction, Chandak Ankit founded BuildVision to bridge the gap between blueprint and reality. Every project we take on carries his obsession with detail — from the first sketch to the final key.",
    ethos: "I don't want my clients to hope their home will feel right. I want them to know — before a single brick is laid.",
};

export const SERVICES = [
    {
        icon: "PenRuler",
        title: "2D Floor Planning",
        desc: "Precise, functional layouts crafted around how you actually live and work.",
    },
    {
        icon: "Building2",
        title: "3D Exterior Visualization",
        desc: "Photoreal exteriors with lighting, materials, and landscaping in cinematic quality.",
    },
    {
        icon: "Sofa",
        title: "Ultra-Realistic Interior Design",
        desc: "Every room rendered to feel lived-in — textures, tones, and moods that translate to build.",
    },
    {
        icon: "Video",
        title: "360° Walkthrough Animation",
        desc: "Immersive fly-through videos that let you walk your home before it exists.",
    },
    {
        icon: "Glasses",
        title: "VR Home Experience",
        desc: "Step inside your project with true-scale VR — decide with your senses, not sketches.",
    },
    {
        icon: "Ruler",
        title: "Structural Planning Guidance",
        desc: "Buildable, code-conscious plans reviewed for efficiency and structural sanity.",
    },
    {
        icon: "Hammer",
        title: "Renovation Visualization",
        desc: "See renovations side-by-side, before-and-after — no guesswork, no regrets.",
    },
    {
        icon: "Trees",
        title: "Landscape Design",
        desc: "Gardens, driveways, and outdoor rooms designed to breathe with your architecture.",
    },
    {
        icon: "Store",
        title: "Commercial Building Visualization",
        desc: "Retail, office, and hospitality visuals engineered to win approvals and clients.",
    },
    {
        icon: "Church",
        title: "Church & Institutional Design",
        desc: "Sacred and civic spaces designed with reverence, symmetry, and community in mind.",
    },
];

export const WHY_CHOOSE = [
    { title: "Save Lakhs Before Construction", desc: "Eliminate costly on-site changes with pre-build clarity." },
    { title: "Photorealistic Visualizations", desc: "Renders indistinguishable from finished builds." },
    { title: "Accurate Planning", desc: "Dimensions, sight-lines and materials — verified in 3D." },
    { title: "Premium Quality", desc: "Studio-grade output at every scale, every detail." },
    { title: "Fast Delivery", desc: "Rigorous timelines without cutting corners." },
    { title: "Client-Centric Design", desc: "Your lifestyle and aspirations lead every decision." },
    { title: "Affordable Pricing", desc: "Luxury outcomes without the luxury markup." },
    { title: "Personalized Consultation", desc: "One-on-one guidance from concept to keys." },
];

export const PORTFOLIO = [
    {
        id: "villa-1",
        category: "Luxury Villas",
        title: "Hillside Villa · Jubilee Hills",
        img: "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef",
        span: "col-span-2 row-span-2",
    },
    {
        id: "villa-2",
        category: "Luxury Villas",
        title: "Coastline Retreat",
        img: "https://images.unsplash.com/photo-1582610116397-edb318620f90",
    },
    {
        id: "modern-1",
        category: "Modern Houses",
        title: "Cantilever House",
        img: "https://images.pexels.com/photos/31737859/pexels-photo-31737859.jpeg",
    },
    {
        id: "apt-1",
        category: "Apartments",
        title: "Skyline Residences",
        img: "https://images.pexels.com/photos/18153132/pexels-photo-18153132.jpeg",
    },
    {
        id: "apt-2",
        category: "Apartments",
        title: "Urban Loft Tower",
        img: "https://images.pexels.com/photos/35339499/pexels-photo-35339499.jpeg",
        span: "col-span-2",
    },
    {
        id: "com-1",
        category: "Commercial",
        title: "Glass Facade Office",
        img: "https://images.unsplash.com/photo-1621831337128-35676ca30868",
    },
    {
        id: "com-2",
        category: "Commercial",
        title: "Retail Boulevard",
        img: "https://images.pexels.com/photos/16370914/pexels-photo-16370914.jpeg",
    },
    {
        id: "church-1",
        category: "Church",
        title: "Cathedral of Light",
        img: "https://images.unsplash.com/photo-1666209925785-d9facf88a438",
        span: "col-span-2",
    },
    {
        id: "church-2",
        category: "Church",
        title: "Community Chapel",
        img: "https://images.unsplash.com/photo-1631560791099-9143513a4fbe",
    },
    {
        id: "int-1",
        category: "Interior",
        title: "Warm Minimal Living",
        img: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3",
    },
    {
        id: "int-2",
        category: "Interior",
        title: "Sculpted Kitchen",
        img: "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg",
    },
];

export const PORTFOLIO_FILTERS = [
    "All",
    "Luxury Villas",
    "Modern Houses",
    "Apartments",
    "Commercial",
    "Church",
    "Interior",
];

export const PROCESS = [
    { title: "Consultation", desc: "We listen — to your site, story, and standards." },
    { title: "Requirement Analysis", desc: "Program, budget, timeline. Aligned in writing." },
    { title: "Concept Design", desc: "Sketches, moodboards, and spatial studies." },
    { title: "3D Visualization", desc: "Ultra-realistic renders and walkthroughs." },
    { title: "Client Review", desc: "Iterate together until every detail feels right." },
    { title: "Final Delivery", desc: "Package: renders, animations, drawings, VR." },
    { title: "Construction Support", desc: "On-call guidance so builds stay true to vision." },
];

export const TESTIMONIALS = [
    {
        name: "Rohit & Anjali Sharma",
        role: "Homeowners · Hyderabad",
        quote:
            "We walked through our home in VR six months before it was built. Every material choice suddenly felt obvious. CHANDAK BuildVision saved us from expensive second-guessing.",
    },
    {
        name: "Fr. Immanuel D'Souza",
        role: "Community Church Project",
        quote:
            "The team treated our chapel with reverence and craft. The visualization convinced our board on the very first review.",
    },
    {
        name: "Meera Reddy",
        role: "Boutique Developer",
        quote:
            "Their renders sell units before the foundation is dug. Elegant, honest, and remarkably fast.",
    },
    {
        name: "Karthik Rao",
        role: "Restaurant Owner",
        quote:
            "From concept to construction support — a rare, end-to-end partner. Our guests feel the difference every night.",
    },
];

export const STATS = [
    { value: "100+", label: "Designs Delivered" },
    { value: "95%", label: "Client Satisfaction" },
    { value: "50+", label: "Happy Clients" },
    { value: "10k+", label: "Hours of Design" },
];
